import React, { useState, useMemo, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useTable, usePagination } from 'react-table';
import moment from 'moment';

const UnsupportedT1Symbols = (props) => {
  
  //pagination
  const [pages, setPages] = useState([]);

  const formatTimestamp = (ts) => {
    if (ts) {
      return moment(ts).format('DD MMM, hh:mm A');
    }
  };

  //T+1 table data
  const columns = useMemo(() => {
    if (props.data) {
      return [
        {
          Header: 'SYMBOL',
          accessor: 'ticker',
        },
        {
          Header: 'TYPE',
          accessor: 'ticker_type',
        },
        {
          Header: 'T+1 Units',
          accessor: 'is_tplusoneholding',
        },
        {
          Header: 'IMPORTED AT',
          accessor: 'timestamp',
          Cell: (props) => {
            return formatTimestamp(props.row.original.timestamp);
          },
        },
      ];
    }
    return [];
  }, [props.data]);

  const data = useMemo(() => {
    if (props.data) {
      return props.data;
    }
  }, [props.data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 6 },
    },
    usePagination,
  );

  useEffect(() => {
    if (props.data) {
      const unsupportedLength = props.data.length;
      const pages = Math.ceil(unsupportedLength / 6);
      if (pages <= 7) {
        setPages(new Array(pages).fill().map((_v, _idx) => _idx + 1));
      }
    }
  }, [props.data]);

  return (
    <div className={`unsupported-symbols ${props.show ? '' : 'd-none'}`}>
      <h6 className="title">T+1 Symbols</h6>
      <p className="info">
        We do not support the T+1 holdings. Symbols will reflect once shares
        hit your demat
      </p>
      <table className="table-unsupported">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className={`${
                  row.original.timestamp === props.timestamp ? 'highlight' : ''
                }`}
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {pages.length > 1 && (
        <div className="pagination mb-4">
          <button
            type="button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Prev
          </button>
          <div className="paginate-pages">
            {pages.map((_page, _idx) => {
              return (
                <div
                  key={_page}
                  className={`page-no ${_idx === pageIndex && 'active'}`}
                >
                  {_page}
                </div>
              );
            })}
          </div>
          <button
            type="button"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </button>
        </div>
      )}
      <div className="action mb-2">
        <button
          type="button"
          className="back-btn"
          onClick={() => {
            props.setShow(false);
            props.setShowImportSummary(true);
          }}
        >
          OKAY
        </button>
      </div>
    </div>
  );
};

export default UnsupportedT1Symbols;
